import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const agariBrandProtection = defineConnector({
  identifier: "agariBrandProtection",
  name: "Agari Brand Protection",
  tagLine: "DMARC enforcement and brand impersonation protection",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.agari\\.com/v1/cp/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Generate API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In Agari Brand Protection, click your username, select **Settings**, then click **Generate API Secret** to obtain a client ID and client secret.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://api.agari.com/v1/cp/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.agari.com/v1/cp/threat_feeds",
  },
});
